import { useIsFeatureEnabled } from '@innovyze/stylovyze';

interface AssetSchemaFF {
	[systemType: string]: boolean | string[];
}

export const useAssetSchemaFF = () => {
	const riskNewSchemaFF = useIsFeatureEnabled(
		'info-360-risk-enable-stormwater', // Not best name, but this was the working title
	);

	let assetSchemaFF: AssetSchemaFF;
	// Needed to test the new schema
	if (riskNewSchemaFF) {
		assetSchemaFF =
			(useIsFeatureEnabled(
				'i360-release-asset-schema',
			) as unknown as AssetSchemaFF) ?? {};
	} else {
		assetSchemaFF = {
			SanitarySewer: ['wwPipe'],
			WaterDistribution: ['pipe'],
		};
	}

	const validSystemTypes = Object.keys(assetSchemaFF).filter(
		systemType =>
			assetSchemaFF[systemType] === true ||
			Array.isArray(assetSchemaFF[systemType]),
	);

	const allSystemTypesValid = validSystemTypes.length === 0;

	const isValidSystemType = (systemType: string) =>
		validSystemTypes.includes(systemType) || allSystemTypesValid;

	const isValidAssetType = (systemType: string, assetType: string) => {
		if (allSystemTypesValid) {
			return true;
		}
		const assetTypes = assetSchemaFF[systemType];
		if (assetTypes === true) {
			return true;
		}
		if (Array.isArray(assetTypes)) {
			return assetTypes.includes(assetType);
		}
		return false;
	};

	return {
		isValidSystemType,
		isValidAssetType,
	};
};
